import Inputmask from 'inputmask';
import 'inputmask/dist/inputmask/phone-codes/phone-ru.js';

const selectors = {
    tel: '.js-input-phone',
    mail: '.js-input-email'
};

const customInputMask = () => {
    const inputMaskEmail = new Inputmask('email', { showMaskOnHover: false, clearIncomplete: true });
    const inputMaskTel = new Inputmask('phoneru', { showMaskOnHover: false, clearIncomplete: true });

    inputMaskTel.mask($(selectors.tel));
    inputMaskEmail.mask($(selectors.mail));
};

export default customInputMask;
